import React from 'react';

export default function LinkedText({ children }) {
  const text = String(children || '');
  if (!text) return null;
  const pattern = /((?:https?:\/\/|www\.)[^\s]+)|([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g;
  const output = [];
  let cursor = 0;
  let match;

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > cursor) output.push(text.slice(cursor, match.index));
    if (match[2]) {
      output.push(<a key={'email-' + match.index} href={'mailto:' + match[2]}>{match[2]}</a>);
    } else {
      const raw = match[1];
      const href = raw.startsWith('http') ? raw : 'https://' + raw;
      let label = raw;
      try { label = new URL(href).origin; } catch {}
      output.push(<a key={'url-' + match.index} href={href} target="_blank" rel="nofollow noopener noreferrer">{label}</a>);
    }
    cursor = pattern.lastIndex;
  }
  if (cursor < text.length) output.push(text.slice(cursor));
  return output;
}
